export default __webpack_public_path__ + "08cac26b8586a001530b56b8b5910e1c.jpg";